function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(-16.000000, -10.000000)",
  fill: "#484848"
}, React.createElement("g", {
  transform: "translate(13.000000, 10.000000)"
}, React.createElement("g", {
  transform: "translate(3.409091, 0.000000)"
}, React.createElement("path", {
  d: "M1.48601399,7.41372378 C0.665734266,7.41372378 0,8.07945804 0,8.89973776 L0,14.8437937 C0,15.6640734 0.665734266,16.3298077 1.48601399,16.3298077 C2.30629371,16.3298077 2.97202797,15.6640734 2.97202797,14.8437937 L2.97202797,8.89973776 C2.97202797,8.07871503 2.30629371,7.41372378 1.48601399,7.41372378 Z",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M17.8321678,7.41372378 C17.0118881,7.41372378 16.3461538,8.07945804 16.3461538,8.89973776 L16.3461538,14.8437937 C16.3461538,15.6640734 17.0118881,16.3298077 17.8321678,16.3298077 C18.6524476,16.3298077 19.3181818,15.6640734 19.3181818,14.8437937 L19.3181818,8.89973776 C19.3181818,8.07871503 18.6524476,7.41372378 17.8321678,7.41372378 Z",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M3.71503497,19.3018357 L5.20104895,19.3018357 L5.20104895,23.0168706 C5.20104895,23.8371503 5.86678322,24.5028846 6.68706294,24.5028846 C7.50734266,24.5028846 8.17307692,23.8371503 8.17307692,23.0168706 L8.17307692,19.3018357 L11.1451049,19.3018357 L11.1451049,23.0168706 C11.1451049,23.8371503 11.8108392,24.5028846 12.6311189,24.5028846 C13.4513986,24.5028846 14.1171329,23.8371503 14.1171329,23.0168706 L14.1171329,19.3018357 L15.6031469,19.3018357 L15.6031469,8.15673077 L3.71503497,8.15673077 L3.71503497,19.3018357 Z",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M13.1683129,2.62281469 L13.9313811,1.30100524 C14.0346591,1.12268357 13.9737325,0.896066434 13.7946678,0.792788462 C13.6178322,0.68951049 13.389729,0.750437063 13.2871941,0.929501748 L12.5434441,2.21787587 C11.688986,1.7423514 10.7067308,1.46966783 9.65909091,1.46966783 C8.61219406,1.46966783 7.62993881,1.7423514 6.77473776,2.21861888 L6.03024476,0.928758741 C5.92696678,0.75118007 5.70109266,0.690253497 5.52202797,0.792788462 C5.34519231,0.895323427 5.28426573,1.12194056 5.38605769,1.30026224 L6.14986888,2.62281469 C4.67648601,3.70463287 3.71503497,5.44475524 3.71503497,7.41372378 L15.6031469,7.41372378 C15.6031469,5.44475524 14.6416958,3.70463287 13.1683129,2.62281469 Z M7.43006993,5.1847028 C7.01918706,5.1847028 6.68706294,4.85257867 6.68706294,4.4416958 C6.68706294,4.03081294 7.01918706,3.69868881 7.43006993,3.69868881 C7.8409528,3.69868881 8.17307692,4.03081294 8.17307692,4.4416958 C8.17307692,4.85257867 7.8409528,5.1847028 7.43006993,5.1847028 Z M11.8881119,5.1847028 C11.477229,5.1847028 11.1451049,4.85257867 11.1451049,4.4416958 C11.1451049,4.03081294 11.477229,3.69868881 11.8881119,3.69868881 C12.2989948,3.69868881 12.6311189,4.03081294 12.6311189,4.4416958 C12.6311189,4.85257867 12.2989948,5.1847028 11.8881119,5.1847028 Z",
  fillRule: "nonzero"
})))));

const SvgAndroidIcon = ({
  svgRef,
  title,
  ...props
}) => React.createElement("svg", _extends({
  width: "20px",
  height: "25px",
  viewBox: "0 0 20 25",
  ref: svgRef
}, props), title ? React.createElement("title", null, title) : null, _ref);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgAndroidIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/android-icon.e6450a0c.svg";
export { ForwardRef as ReactComponent };